export function validateFlag(data) {
  const { candleDuration } = data;
  if (candleDuration <= 0 || !Number.isInteger(candleDuration))
    return [false, 'Candle Duration must be a whole number larger than zero.'];
  return [true, ''];
}
